import { create } from 'zustand';
import { CartItem, PrintServices } from '../types/cart';
import { generateId } from '../utils/generateId';

interface CartState {
  items: CartItem[];
  totalAmount: number;
  addItem: (item: CartItem) => void;
  removeItem: (id: string) => void;
  clearCart: () => void;
  incrementQuantity: (id: string) => void;
  decrementQuantity: (id: string) => void;
  updateItemServices: (id: string, services: PrintServices) => void;
}

export const useCartStore = create<CartState>((set) => ({
  items: [],
  totalAmount: 0,
  addItem: (item: CartItem) => {
    set((state) => ({
      items: [...state.items, item],
      totalAmount: state.items.reduce((total, i) => total + (i.price * i.quantity), 0) + (item.price * item.quantity)
    }));
  },
  removeItem: (id) =>
    set((state) => {
      const newItems = state.items.filter(item => item.id !== id);
      return {
        items: newItems,
        totalAmount: newItems.reduce((total, item) => total + (item.price * item.quantity), 0)
      };
    }),
  clearCart: () => set({ items: [], totalAmount: 0 }),
  incrementQuantity: (id) =>
    set((state) => {
      const newItems = state.items.map(item =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      );
      return {
        items: newItems,
        totalAmount: newItems.reduce((total, item) => total + (item.price * item.quantity), 0)
      };
    }),
  decrementQuantity: (id) =>
    set((state) => {
      const newItems = state.items.map(item =>
        item.id === id && item.quantity > 1 
          ? { ...item, quantity: item.quantity - 1 } 
          : item
      );
      return {
        items: newItems,
        totalAmount: newItems.reduce((total, item) => total + (item.price * item.quantity), 0)
      };
    }),
  updateItemServices: (id: string, services: PrintServices) =>
    set((state) => {
      const newItems = state.items.map(item =>
        item.id === id ? { ...item, services } : item
      );
      return { items: newItems };
    }),
}));